import { ReactNode } from "react";
import ContainerWrapper from "@/components/ui/ContainerWrapper";

type LegalDocumentProps = {
  title: string;
  children: ReactNode;
};

/**
 * Text layout for the legal pages (/terms, /privacy, /dmca, /acceptable-use),
 * replacing the embedded PDF viewer. Content components render bare semantic
 * tags; this wrapper styles them via descendant selectors so every document
 * reads the same without repeating classes through hundreds of paragraphs.
 */
export default function LegalDocument({ title, children }: LegalDocumentProps) {
  return (
    <ContainerWrapper maxWidth="860px" className="pt-[40px] pb-[80px]">
      <h1 className="text-[32px] font-bold text-black mb-[24px]">{title}</h1>
      <div
        className="text-[14px] leading-[1.7] text-text-secondary
          [&_h2]:text-[20px] [&_h2]:font-semibold [&_h2]:text-black [&_h2]:mt-[32px] [&_h2]:mb-[12px]
          [&_h3]:text-[16px] [&_h3]:font-semibold [&_h3]:text-black [&_h3]:mt-[20px] [&_h3]:mb-[8px]
          [&_p]:mb-[12px]
          [&_ul]:list-disc [&_ul]:pl-[22px] [&_ul]:mb-[12px]
          [&_ol]:list-decimal [&_ol]:pl-[22px] [&_ol]:mb-[12px]
          [&_li]:mb-[6px]
          [&_strong]:text-black
          [&_a]:text-brand-primary [&_a]:underline"
      >
        {children}
      </div>
    </ContainerWrapper>
  );
}
